import React, { useContext, useEffect, useRef, useState } from "react";
import UserContext from "../../../utils/Contexts/UserContext";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import axiosInstance from "../../../utils/Requests/axios";
import toast from "react-hot-toast";
import RightArrow from "../../svg/RightArrow";

function DueCompletion() {
  const { userData } = useContext(UserContext);
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(null);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);
  const dueCompletionPayload = {
    columns: [{ data: "created" }],
    order: [{ column: 0, dir: "asc" }],
    search: {
      filters: [{ key: "STATUS", value: 4 }],
    },
  };

  const contractStatusType = {
    0: {
      title: t("Created"),
      class: "text-gray bg-soft-secondary",
      contractClass: "text-gray",
    },
    1: {
      title: t("Waiting Acceptance"),
      class: "text-warning bg-softer-warning",
      contractClass: "text-warning",
    },
    2: {
      title: t("Declined"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    3: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    4: {
      title: t("In Progress"),
      class: "text-primary bg-soft-primary",
      contractClass: "text-primary",
    },
    5: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    6: {
      title: t("Approved"),
      class: "text-info bg-soft-primary",
      contractClass: "text-info",
    },
    7: {
      title: t("Rejected"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    8: {
      title: t("Declined"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    9: {
      title: t("Completed"),
      class: "text-success bg-soft-success",
      contractClass: "text-success",
    },
    10: {
      title: t("Deleted"),
      class: "text-muted bg-soft-danger",
      contractClass: "text-muted",
    },
    11: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    12: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
  };

  const dueCompletion = useRef(false);
  const fetchDueCompletion = () => {
    if (dueCompletion.current) return;
    dueCompletion.current = true;
    const payload = _.cloneDeep(dueCompletionPayload);
    const url = `users/${userData?.uuid}/contracts/search`;
    axiosInstance
      .post(url, payload)
      .then((response) => {
        setTableData(response?.data?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching backlinks offers"));
      });
  };

  useEffect(() => {
    fetchDueCompletion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const linkTypesItems = {
    1: t("Do Follow"),
    2: t("No Follow"),
    3: t("Sponsored"),
  };

  const linkTypesItemsStyles = {
    [t("Do Follow")]: "text-primary",
    [t("No Follow")]: "",
    [t("Sponsored")]: "custom-text-gray",
  };

  const placementItems = {
    1: t("Guest Post"),
    2: t("Link Insert"),
    3: t("Niche Edit"),
  };

  const navigateToOpenDetails = (uuid) => {
    navigate(`/contracts/${uuid}`);
  };

  return (
    <div
      className={`w-100 pt-3 rounded cardSetting pb-2 ${themeStatus?.[selectedTheme]}`}
      style={{ backgroundColor: "var(--bg-card)" }}
    >
      <div className="d-flex justify-content-between align-items-center px-3 pb-3">
        <h4 className="card-title p-0 mb-0" style={{ lineHeight: "150%" }}>
          {t("Contract Due Completion")}
        </h4>
        <p
          className="card-text cursor-pointer d-flex align-items-center gap-1 see-more-news"
          onClick={() => navigate("/contracts")}
        >
          {t("See More")} <RightArrow />
        </p>
      </div>
      <div
        className={`table-responsive datatable-custom ${themeStatus?.[selectedTheme]}`}
      >
        <table
          className="table table-thead-bordered table-nowrap card-table"
          style={{ border: "transparent" }}
        >
          <thead className="thead-light">
            <tr>
              <th>{t("CONTRACT")}</th>
              <th>{t("PLACEMENT")}</th>
              <th>{t("LINK TYPE")}</th>
              <th>{t("TIME LEFT")}</th>
              <th>{t("PRICE")}</th>
            </tr>
          </thead>

          <tbody>
            {!!tableData?.length ? (
              tableData?.map((item, index) => {
                const now = moment();
                const end = moment(item?.moneyback_policy_ends);
                const duration = moment.duration(end.diff(now));

                const daysLeft = Math.max(duration.asDays(), 0);
                const totalDays = 365;

                const percentage = Math.max(
                  100 - (daysLeft / totalDays) * 100,
                  0
                );

                return (
                  <React.Fragment key={index}>
                    <tr className="align-middle">
                      <td>
                        <div
                          className={`${
                            contractStatusType[item?.status]?.contractClass
                          } responsive-text-onHold text-decoration-underline cursor-pointer`}
                          onClick={() => navigateToOpenDetails(item?.uuid)}
                        >
                          {item?.code}
                        </div>
                      </td>

                      <td className="align-middle pt-3">
                        <div className="custom-text-gray responsive-text-onHold">
                          {placementItems[item?.type]}
                        </div>
                      </td>

                      <td className="align-middle pt-3">
                        <div
                          className={`responsive-text-onHold ${
                            linkTypesItemsStyles[linkTypesItems[item?.rel]]
                          }`}
                        >
                          {item?.links} · {linkTypesItems[item?.rel]}
                        </div>
                      </td>
                      <td>
                        <div
                          className="text-white responsive-text-onHold"
                          style={{ fontWeight: "700" }}
                        >
                          ${item?.price}
                        </div>
                      </td>
                      <td className="align-middle pt-3">
                        <div
                          className="due-acceptance-progress"
                          style={{
                            padding: "2px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "5px",
                            backgroundColor: "transparent",
                            position: "relative",
                          }}
                        >
                          <div
                            className="progress"
                            style={{
                              height: "18px",
                              width: "100%",
                              borderRadius: "3px",
                              backgroundColor: "var(--separator-bg)",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div
                              className="progress-bar bg-primary"
                              role="progressbar"
                              style={{
                                width: `${percentage}%`,
                                height: "100%",
                                borderRadius: "3px 0 0 3px",
                                transition: "width 0.4s ease",
                              }}
                              aria-valuenow={percentage}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            />
                            <span
                              className="text-start ps-0"
                              style={{
                                color: "var(--days-left)",
                                position: "absolute",
                                top: "45%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                            >
                              {daysLeft > 0
                                ? `${Math.floor(daysLeft)} ${t(
                                    daysLeft === 1 ? "day left" : "days left"
                                  )}`
                                : `0 ${t("days left")}`}
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>

                    {index !== tableData?.length - 1 && (
                      <tr>
                        <td
                          colSpan="100%"
                          className="px-3 py-0"
                          style={{ border: "transparent" }}
                        >
                          <div
                            style={{
                              width: "calc(100% - 2px)",
                              height: "2px",
                              backgroundColor:
                                selectedTheme === "dark"
                                  ? "rgba(45, 50, 54, 1)"
                                  : "rgba(45, 50, 54, 0.2)",
                              margin: "0 auto",
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan="100%">
                  <div
                    className="text-center p-4"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="mb-3"
                      src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                      alt=""
                      style={{ width: "10rem" }}
                      data-hs-theme-appearance="dark"
                    />
                    <img
                      className="mb-3"
                      src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                      alt=""
                      style={{ width: "10rem" }}
                      data-hs-theme-appearance="default"
                    />
                    <p className="mb-0">
                      {!tableData ? t("Loading data") : t("No data to show")}
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DueCompletion;
